import { render } from "./ranking.vue?vue&type=template&id=40662f78"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__